import React, { FC } from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { TransportType } from '../../../../generated/graphql';

type StopoverQuantityMessageProps = {
  quantity: number;
  transportTypes: TransportType[];
};

const StopoverQuantityMessage: FC<StopoverQuantityMessageProps> = ({
  quantity,
  transportTypes,
}) => {
  const isDirect = quantity === 0;
  const { t } = useTranslation();
  const key = transportTypes.includes(TransportType.Train)
    ? t('results.segment.stops.train', {
        count: quantity,
        context: isDirect ? 'none' : 'some',
      })
    : t('results.segment.stops', {
        count: quantity,
        context: isDirect ? 'none' : 'some',
      });
  return <>{key}</>;
};

export default StopoverQuantityMessage;
